import { createModel } from "@rematch/core";
import { RootModel } from "./index";

/**
 * Whether the browser holds a usable session, and nothing else.
 *
 * This was a form state machine — email, password, confirmPassword,
 * confirmationCode, newPassword, per-field errors and a `validateField` effect
 * with password regexes — back when Cognito was signed into with a username and
 * a password. Sign-in is two OAuth buttons now (`components/forms/LoginForm`),
 * so none of it had a caller left.
 *
 * The token itself is not in here: `auth/session` owns that, and this flag is
 * derived from it (`auth/bootstrap`). Redux holds it so a 401 in the API
 * interceptor can re-render the app signed-out without a reload.
 */
interface AuthState {
  isUserAuthenticated: boolean;
}

export const auth = createModel<RootModel>()({
  state: {
    isUserAuthenticated: false,
  } as AuthState,

  reducers: {
    setUserAuthenticated(state, payload: boolean) {
      return { ...state, isUserAuthenticated: payload };
    },
  },
});
